module.exports = "<label class=\"section-label pull-left text-uppercase\">{{options.templateOptions.labelOptions.label}}</label><br/>\n<div>\n    <label class=\"col-xs-6 control-label\">If you have a voucher code please add it here:</label>\n    <div class=\"form-group col-xs-5\">\n        <formly-transclude></formly-transclude>\n    </div>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./static/js/app/layout/formly/wrappers/cart-voucher-input.html
// module id = 621
// module chunks = 1